import React, { FC } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { PromoLoyaltyMetaConfig } from '~/services/PromoService';

interface LoyaltyPromoProductTypeOptionsSelectorProps {
  promoLoyaltyMetaConfig: PromoLoyaltyMetaConfig | null;
  isPromoMetaLoading: boolean;
  value: string;
  onChange: (value: string) => void;
  isErroring?: boolean;
}

const LoyaltyPromoProductTypeOptionsSelector: FC<LoyaltyPromoProductTypeOptionsSelectorProps> = ({
  promoLoyaltyMetaConfig,
  isPromoMetaLoading,
  value,
  onChange,
  isErroring = false,
}) => {
  if (isPromoMetaLoading || !promoLoyaltyMetaConfig?.loyaltyProductTypeOptions?.length) {
    return null;
  }

  const options = promoLoyaltyMetaConfig.loyaltyProductTypeOptions;

  return (
    <Autocomplete
      value={options.find((option) => option.key === value) || null}
      options={options}
      getOptionLabel={(option) => option.name || option.key}
      isOptionEqualToValue={(option, value) => option.key === value?.key}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Limit to Product Type (optional)"
          helperText="This loyalty reward will only apply to the selected product type. If no product type is selected, the reward will apply to all product types."
          error={isErroring}
        />
      )}
      onChange={(e: unknown, newValue: any) => {
        onChange(newValue?.key || '');
      }}
    />
  );
};

export default LoyaltyPromoProductTypeOptionsSelector;
